import React, { useState, useEffect, useMemo } from 'react';
import apiClient from "../utils/apiClient";
import { useTable, usePagination, useGlobalFilter } from 'react-table';
import { useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { SERVER_BASE } from '../config/server';
import Swal from 'sweetalert2';
import moment from 'moment';
import OutDocumentModal from './OutDocumentModal';

const SecurityOutForm = ({ permissions }) => {
  const [profileDetails, setProfileDetails] = useState(null);
  const code = localStorage.getItem('code');
  const email = localStorage.getItem('email'); // Retrieve email from localStorage
  const role = localStorage.getItem('role'); // Retrieve email from localStorage
  const [combinedData, setCombinedData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const token = localStorage.getItem('token');
  const [selectedRow, setSelectedRow] = useState(null);
  const [showOutModal, setShowOutModal] = useState(false);
  const sewadarId = localStorage.getItem('sewadarId');
  const [receivedDocs, setReceivedDocs] = useState("");
  const [docType, setDocType] = useState("");
  const [senderName, setSenderName] = useState("");
  const [securitySewadars, setSecuritySewadars] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  // New states for permission details
  const [permissionDetails, setPermissionDetails] = useState({
    permitBy: "",
    byWhom: "",
    medium: "",
    permitByDate: "",
    permitByTime: "",
    authorityName: "",
    letterIssuerName: "",
    exitDate: "",
    exitTime: ""
  });

  // Handler for permission details form
  const handlePermissionChange = (e) => {
    const { name, value } = e.target;
    setPermissionDetails(prev => ({
      ...prev,
      [name]: value
    }));
  };
  // Fetch combined data from backend
  let profileData = []

  const fetchData = async () => {
    try {
      // Single API call to fetch combined data
      const response = await apiClient.get(SERVER_BASE + '/combined-data');

      setCombinedData(response.data); // Data already includes the 'type' field
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchChallanCompletedData = async () => {
    try {
      // Single API call to fetch combined data
      const response = await apiClient.get(SERVER_BASE + '/challansCompletedData');
      setCompletedData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  useEffect(() => {
    fetchData();
    fetchChallanCompletedData();
  }, []);


  useEffect(() => {

    const fetchProfileDetails = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email, role } });
        profileData = response.data[0]
        setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
      } catch (err) {
        console.error('Error fetching profile details:', err);
        setProfileDetails(null);
      }
    };
    fetchProfileDetails();
  }, [code, email]);


  const openOutModal = (rowData) => {
    setSelectedRow(rowData);
    setShowOutModal(true);
  };
  const closeOutModal = () => {
    resetModalData();
    setShowOutModal(false);
  };

const fetchSewadars = async () => {
  const dept = "Security,Satsang,Office,Office";

  const res = await apiClient.get(
    `${SERVER_BASE}/getOperatorsByDepartment/${code}?department=${dept}`
  );

  const badgeOptions = res.data.map((s) => ({
    value: s.badgeId,
    label: `${s.badgeId} - ${s?.fullName}`,
    name: s?.fullName,
    sewadarMobileNo: s.mobileNo,
    alternateMobileNo: s.alternateMobileNo,
  }));

  setSecuritySewadars(badgeOptions);
};


  useEffect(() => {
    fetchSewadars();
  }, [code]);
  const resetModalData = () => {
    setReceivedDocs("");
    setDocType("");
    setSenderName("");
    setPermissionDetails({
      permitBy: "",
      byWhom: "",
      medium: "",
      permitByDate: "",
      permitByTime: "",
      authorityName: "",
      letterIssuerName: "",
      exitDate: "",
      exitTime: ""
    });
    setSelectedRow(null);
  };


  const handleModalSubmit = async (docData) => {
    setShowOutModal(false);

    try {
      const { isConfirmed } = await Swal.fire({
        title: 'क्या आप सुनिश्चित हैं?',
        text: 'यह वाहन बाहर के रूप में चिह्नित किया जाएगा।',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'रद्द करें',
        confirmButtonText: 'हाँ, आगे बढ़ें',
      });
      if (isConfirmed) {
        const outBy = `${profileDetails.firstName} ${profileDetails.lastName}`;
        const outByBadge = profileDetails.badgeId;
        const outByTime = new Date(new Date().getTime() + 330 * 60000)
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ');
        const payload = {
          id: selectedRow.id,
          type: selectedRow.type || null,
          sewadarBadgeId: securitySewadars[0]?.value || null,
          sewadarName: securitySewadars[0]?.name || null,
          sewadarMobileNo: securitySewadars[0]?.sewadarMobileNo || null,
          senderName: senderName || null,
          docType: docType || null,
          receivedDocs: receivedDocs || null,
          authorityName: permissionDetails.authorityName || null,
          byWhom: permissionDetails.byWhom || null,
          letterIssuerName: permissionDetails.letterIssuerName || null,
          medium: permissionDetails.medium || null,
          permitBy: permissionDetails.permitBy || null,
          permitByDate: permissionDetails.permitByDate || null,
          permitByTime: permissionDetails.permitByTime || null,
          exitDate: permissionDetails?.exitDate || null,
          exitTime: permissionDetails?.exitTime || null,
          sewadarId,
          code
        }


        try {
          await apiClient.post(`${SERVER_BASE}/updateStatus/${selectedRow.id}`, payload);
          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            icon: 'success',
            text: 'Vehicle Out successfully.',
            timerProgressBar: true,
            timer: 1000,
          }).then(() => {
            fetchData();
            fetchChallanCompletedData();
            resetModalData(); // ✅ Clear fields after submit
          });

        } catch (err) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `Failed to out the vehicle: ${err.response?.data?.message || err.message}`,
            confirmButtonText: 'OK',
          });
        }
      }
    } catch (error) {
      console.error('Error handling Out click:', error);
      Swal.fire({
        icon: 'error',
        title: 'Unexpected Error',
        text: error.message,
        confirmButtonText: 'OK',
      });
    }
  };


  // const handleOutClick = async (rowData) => {

  //   try {
  //     const { isConfirmed, value } = await Swal.fire({
  //       title: 'Enter your PIN',
  //       input: 'password',
  //       inputPlaceholder: 'Enter your PIN',
  //       showCancelButton: true,
  //       cancelButtonText: 'Cancel',
  //       confirmButtonText: 'Submit',
  //       inputValidator: (value) => {
  //         if (!value) {
  //           return 'Please enter your PIN.';
  //         }
  //         if (value !== profileData?.pin) {
  //           return 'Invalid PIN. Please try again.';
  //         }
  //       },
  //     });

  //     if (isConfirmed) {
  //       // Proceed with the approval
  //       const outBy = `${profileData.firstName} ${profileData.lastName}`;
  //       const outByBadge = profileData.badgeId;
  //       const outByTime = new Date(new Date().getTime() + 330 * 60000) // Adjust to UTC+5:30
  //     .toISOString()
  //     .slice(0, 19)
  //     .replace('T', ' ');
  //       // Update the vehicle status in the backend
  //       try {
  //         await apiClient.put(`${SERVER_BASE}/updateStatus/${rowData.id}`, {
  //           id: rowData.id,
  //           type:rowData.type,
  //           outBy,
  //           outByBadge,
  //           outByTime
  //         });

  //         // Success feedback
  //         Swal.fire({
  //           toast:true,
  //           position: 'top-end',
  //           showConfirmButton: false,
  //           icon: 'success',
  //           text: 'Vehicle Out successfully.',
  //           timerProgressBar:true,
  //           timer: 1000,
  //         }).then(() => {
  //           fetchData(); // Call fetchData inside a function
  //           fetchChallanCompletedData();
  //         });


  //       } catch (err) {
  //         // Handle API errors
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error',
  //           text: `Failed to out the vehicle: ${err.response?.data?.message || err.message}`,
  //           confirmButtonText: 'OK',
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error handling Out click:', error);
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Unexpected Error',
  //       text: error.message,
  //       confirmButtonText: 'OK',
  //     });
  //   }
  // };

  const columns = useMemo(() => {
    const cols = [
      {
        Header: 'Date',
        accessor: (row) => (row.type === 'gp' ? row.gatePassDate : row.date),
        Cell: ({ value }) => moment(value).format("DD-MMM-YYYY") || 'N/A',
      },
      {
        Header: 'Ref No./GatePass #',
        accessor: (row) => (row.type === 'gp' ? row.gatePassCode : `${row.prefix}${row.refNo} `),
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Vehicle No.',
        accessor: (row) => (row.type === 'gp' ? row.vehicleNumber : row.VehicleNo),
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Driver Name',
        accessor: (row) => (row.type === 'gp' ? row.driverName : row.name),
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Mobile No.',
        accessor: (row) => (row.type === 'gp' ? row.mobileNum : row.MobileNo),
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Type',
        accessor: 'type',
        Cell: ({ value, row }) => {
          const currentRow = row.original;
  
          const handleClick = () => {
            if (value === "gp") {
              navigate("../../PreviewGatePass", {
                state: { id: currentRow.id },
              });
            } else if (value === "dl") {
              navigate("../../previewDeliveryChallan", {
                state: { id: currentRow.id },
              });
            }
          };
  
          return (
            <span
              style={{color:'blue',cursor: "pointer" }}
              onClick={handleClick}
            >
              {value === "gp"
                ? "Gate Pass"
                : value === "dl"
                ? "Delivery Challan"
                : "Pending"}
            </span>
          );
        },
      },
    ];
  
    // Conditionally add Action column
    if (permissions?.write) {
      cols.unshift({
        Header: 'Action',
        Cell: ({ row }) => (
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => openOutModal(row.original)}
          >
            Out
          </button>
        ),
      });
    }
  
    return cols;
  }, [permissions]);
  

  // Define custom columns for Gate Pass Completed
  const gatePassColumns = useMemo(
    () => [
      {
        Header: 'Gate Pass #',
        accessor: 'gatePassCode',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Vehicle No.',
        accessor: 'vehicleNumber',
        Cell: ({ value, row }) => (
          <span
            onClick={() =>
              navigate("../../PreviewGatePass", {
                state: { id: row.original.id },
              })
            }
            style={{ 
              color: "#007bff",
              cursor: "pointer",
            }}
          >
            {value || 'N/A'}
          </span>
        ),
      },
      
      {
        Header: 'Driver Name',
        accessor: 'driverName',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Mobile No.',
        accessor: 'mobileNum',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Out By',
        accessor: (row) => `${row.outBy}(${row.outByBadge})`,
        Cell: ({ value }) => value,

      },
      {
        Header: 'Out Date',
        accessor: (row) => {
          // Combine date and time into one Date object
          const combinedDateTime = moment(
            `${row.outByDate} ${row.outByTime}`,
            'YYYY-MM-DD HH:mm:ss'
          );
          return combinedDateTime.isValid()
            ? combinedDateTime.format('DD-MMM-YYYY HH:mm:ss')
            : '';
        },
        Cell: ({ value }) => value,
      }

    ],
    []
  );

  // Define custom columns for Delivery Challan Completed
  const deliveryChallanColumns = useMemo(
    () => [
      {
        Header: 'Ref No.',
        accessor: (row) => `${row.prefix}${row.refNo}`,
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Vehicle No.',
        accessor: 'VehicleNo',
        Cell: ({ value, row }) => (
          <span
            onClick={() =>
              navigate("../../previewDeliveryChallan", {
                state: { id: row.original.id },
              })
            }
            style={{
              color: "#007bff",
              cursor: "pointer",
            }}
          >
            {value || 'N/A'}
          </span>
        ),
      },
      
      {
        Header: 'Driver Name',
        accessor: 'name',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Mobile No.',
        accessor: 'MobileNo',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Out By',
        accessor: (row) => `${row.outBy}(${row.outByBadge})`,
        Cell: ({ value }) => value,

      },
      {
        Header: 'Out Date',
        accessor: (row) => {
          // Combine date and time into one Date object
          const combinedDateTime = moment(
            `${row.outByDate} ${row.outByTime}`,
            'YYYY-MM-DD HH:mm:ss'
          );
          return combinedDateTime.isValid()
            ? combinedDateTime.format('DD-MMM-YYYY HH:mm:ss')
            : '';
        },
        Cell: ({ value }) => value,
      }

    ],
    []
  );
  const exceptionalSecurityOutColumns = useMemo(
    () => [
      {
        Header: 'Vehicle No.',
        accessor: 'vehicleNo',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Driver Name',
        accessor: 'driverName',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Mobile No.',
        accessor: 'driverMobileNo',
        Cell: ({ value }) => value || 'N/A',
      },
      {
        Header: 'Permitted By',
        accessor: 'permittedByName',
        Cell: ({ value }) => value,
      },
      {
        Header: 'Out Date & Time',
        accessor: (row) => {
          // Combine date and time into one Date object
          const combinedDateTime = moment(
            `${row.exitDate} ${row.exitTime}`,
            'YYYY-MM-DD HH:mm:ss'
          );
          return combinedDateTime.isValid()
            ? combinedDateTime.format('DD-MMM-YYYY HH:mm:ss')
            : '';
        },
        Cell: ({ value }) => value,
      }

    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Use `page` for pagination
    state: { globalFilter, pageIndex, pageSize },
    setGlobalFilter, // Function to update the search term
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
  } = useTable(
    {
      columns,
      data: combinedData,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter, // Add useGlobalFilter here
    usePagination
  );



  return (
    <div className="container mt-5">
      <h3>Security Out</h3>
      {permissions?.write && 
      <button
        className="btn btn-outline-success mb-3"
        onClick={() => { navigate('../ExceptionalSecurityOut') }}
      >
        Add Exceptional Out
      </button>
      }
      {permissions?.read && (<>
      <form className="formcontainer">
        {/* Tabs using normal Bootstrap */}
        <ul className="nav nav-tabs" id="challansTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <a
              className="nav-link active"
              id="pending-tab"
              data-bs-toggle="tab"
              href="#pending"
              role="tab"
              aria-controls="pending"
              aria-selected="true"
            >
              Pending Challans
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className="nav-link"
              id="exception-tab"
              data-bs-toggle="tab"
              href="#exception"
              role="tab"
              aria-controls="exception"
              aria-selected="false"
            >
              Exceptional Out
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className="nav-link"
              id="gate-pass-tab"
              data-bs-toggle="tab"
              href="#gatePass"
              role="tab"
              aria-controls="gatePass"
              aria-selected="false"
            >
              Gate Pass Completed
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className="nav-link"
              id="delivery-challan-tab"
              data-bs-toggle="tab"
              href="#deliveryChallan"
              role="tab"
              aria-controls="deliveryChallan"
              aria-selected="false"
            >
              Delivery Challan Completed
            </a>
          </li>
        </ul>

        <div className="tab-content mt-3" id="challansTabsContent">
          {/* Pending Challans Tab */}
          <div
            className="tab-pane fade show active"
            id="pending"
            role="tabpanel"
            aria-labelledby="pending-tab"
          >
            <div className='table-responsive'>
            <div className="d-flex gap-2">
              <input
                type="text"
                placeholder="Search..."
                value={globalFilter || ''} // Use globalFilter state
                onChange={(e) => setGlobalFilter(e.target.value || undefined)} // Update globalFilter
                className="form-control w-100"
              />
                 <select
                  value={pageSize}
                  className="form-select"
                  style={{ width: 'auto' }}
                  onChange={(e) => {
                    setPageSize(Number(e.target.value)); // Update the page size
                  }}
                >
                  {[25,50,75,200].map((size) => (
                    <option key={size} value={size}>
                      Show {size}
                    </option>
                  ))}
                </select>
                </div>
              <table {...getTableProps()} className="table table-striped">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>

              </table>
              <div className="pagination d-flex justify-content-between align-items-center">
            
          <button
          type='button'
            className="btn btn-secondary"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            Previous
          </button>
          Page {pageIndex + 1} of {pageCount}
          <button
          type='button'
            className="btn btn-secondary"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            Next
          </button>
       
      </div>

            </div>
          </div>

          {/* Gate Pass Completed Tab */}
          <div
            className="tab-pane fade"
            id="exception"
            role="tabpanel"
            aria-labelledby="exception-tab"
          >
            <div className='table-responsive'>
              <input
                type="text"
                placeholder="Search..."
                value={globalFilter || ''}
                onChange={(e) => setGlobalFilter(e.target.value || undefined)}
                className="form-control mb-3"
              />
              <table className="table table-striped">
                <thead>
                  <tr>
                    {exceptionalSecurityOutColumns.map((column, index) => (
                      <th key={index}>{column.Header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {completedData
                    .filter((row) => row.type == 'manual') // Filter Gate Pass data
                    .filter((row) => {
                      // Apply the global filter here
                      const searchString = globalFilter ? globalFilter.toLowerCase() : '';
                      return (
                        (row.vehicleNo && row.vehicleNo.toLowerCase().includes(searchString)) ||
                        (row.driverName && row.driverName.toLowerCase().includes(searchString)) || 
                        (row.driverMobileNo && row.driverMobileNo.toLowerCase().includes(searchString)) ||
                        (row.permittedByName && row.permittedByName.toLowerCase().includes(searchString)) ||
                        (row.exitDate && row.exitDate.toLowerCase().includes(searchString)) ||
                        (row.exitTime && row.exitTime.toLowerCase().includes(searchString))
                      );
                    }) // Filter Gate Pass data
                    .map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {exceptionalSecurityOutColumns.map((column, colIndex) => (
                          <td key={colIndex}>
                            {typeof column.accessor == 'function'
                              ? column.accessor(row) // Call accessor if it's a function
                              : row[column.accessor] || 'N/A'}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="gatePass"
            role="tabpanel"
            aria-labelledby="gate-pass-tab"
          >
             <div className='table-responsive'>
              <input
                type="text"
                placeholder="Search..."
                value={globalFilter || ''}
                onChange={(e) => setGlobalFilter(e.target.value || undefined)}
                className="form-control mb-3"
              />

              <table className="table table-striped">
                <thead>
                  <tr>
                    {gatePassColumns.map((column, index) => (
                      <th key={index}>{column.Header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {completedData
                    .filter((row) => row.type === 'gp') // Filter Gate Pass data
                    .filter((row) => {
                      // Apply the global filter here
                      const searchString = globalFilter ? globalFilter.toLowerCase() : '';
                      return (
                        (row.gatePassCode && row.gatePassCode.toLowerCase().includes(searchString)) ||
                        (row.vehicleNumber && row.vehicleNumber.toLowerCase().includes(searchString)) ||
                        (row.driverName && row.driverName.toLowerCase().includes(searchString)) ||
                        (row.mobileNum && row.mobileNum.toLowerCase().includes(searchString)) ||
                        (row.status && row.status.toLowerCase().includes(searchString)) ||
                        (row.outByTime && row.outByTime.toLowerCase().includes(searchString)) ||
                        (row.outBy && row.outBy.toLowerCase().includes(searchString)) ||
                        (row.outByBadge && row.outByBadge.toLowerCase().includes(searchString))
                      );
                    }) // Filter Gate Pass data
                    .map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {gatePassColumns.map((column, colIndex) => (
                         <td key={colIndex}>
                         {column.Cell
                           ? column.Cell({
                               value: typeof column.accessor === "function"
                                 ? column.accessor(row)
                                 : row[column.accessor],
                               row: { original: row }
                             })
                           : typeof column.accessor === "function"
                           ? column.accessor(row)
                           : row[column.accessor] || "N/A"}
                       </td>
                       
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Delivery Challan Completed Tab */}
          <div
            className="tab-pane fade "
            id="deliveryChallan"
            role="tabpanel"
            aria-labelledby="delivery-challan-tab"
          >
             <div className='table-responsive'>
              <input
                type="text"
                placeholder="Search..."
                value={globalFilter || ''}
                onChange={(e) => setGlobalFilter(e.target.value || undefined)}
                className="form-control mb-3"
              />
              <div></div>
              <table className="table table-striped">
                <thead>
                  <tr>
                    {deliveryChallanColumns.map((column, index) => (
                      <th key={index}>{column.Header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {completedData
                    .filter((row) => row.type === 'dl') // Filter Delivery Challan data
                    .filter((row) => {
                      // Apply the global filter here
                      const searchString = globalFilter ? globalFilter.toLowerCase() : '';
                      return (
                        (row.prefix && row.prefix.toLowerCase().includes(searchString)) ||
                        (row.refNo && row.refNo.toLowerCase().includes(searchString)) ||
                        (row.VehicleNo && row.VehicleNo.toLowerCase().includes(searchString)) ||
                        (row.name && row.name.toLowerCase().includes(searchString)) ||
                        (row.MobileNo && row.MobileNo.toLowerCase().includes(searchString)) ||
                        (row.outByTime && row.outByTime.toLowerCase().includes(searchString)) ||
                        (row.outBy && row.outBy.toLowerCase().includes(searchString)) ||
                        (row.outByBadge && row.outByBadge.toLowerCase().includes(searchString))
                      );
                    })
                    .map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {deliveryChallanColumns.map((column, colIndex) => (
                         <td key={colIndex}>
                         {column.Cell
                           ? column.Cell({
                               value: typeof column.accessor === "function"
                                 ? column.accessor(row)
                                 : row[column.accessor],
                               row: { original: row }
                             })
                           : typeof column.accessor === "function"
                           ? column.accessor(row)
                           : row[column.accessor] || "N/A"}
                       </td>
                       
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>


      </form>
      {showOutModal && (
        <OutDocumentModal
          show={showOutModal}
          onClose={closeOutModal}  // ✅ use reset-aware close
          onSubmit={handleModalSubmit}
          receivedDocs={receivedDocs}
          setReceivedDocs={setReceivedDocs}
          docType={docType}
          setDocType={setDocType}
          senderName={senderName}
          setSenderName={setSenderName}
          securitySewadars={securitySewadars}
          formData={permissionDetails}
          handleChange={handlePermissionChange}
        />
      )}
      </>)}
    </div>
  );
};

export default SecurityOutForm;
